module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "logosintro"
  }, [_c('div', {
    staticClass: "story fr"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'story'
      }
    }
  }, [_c('img', {
    staticClass: "logoresizing pb3",
    attrs: {
      "src": require("@/assets/The_Story_Button.png")
    }
  })])], 1), _c('div', {
    staticClass: "song fr"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'songs'
      }
    }
  }, [_c('img', {
    staticClass: "logoresizing pb3",
    attrs: {
      "src": require("@/assets/The_Songs_Button.png")
    }
  })])], 1), _c('div', {
    staticClass: "film fr"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'film'
      }
    }
  }, [_c('img', {
    staticClass: "logoresizing pb3",
    attrs: {
      "src": require("@/assets/The_Film_Button.png")
    }
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51f68cef","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 1283
// module chunks = 1